import useApiService from '../utilities/useApiService';
import { useMutation, UseMutationResult } from 'react-query';
import { MutationHandlers } from '../network/models/MutationHandlers';
import { AxiosResponse } from 'axios';
import { ReturnRequestServiceType } from '../utilities/Enums';

interface MutationVariables {
   locationState: { serviceType: ReturnRequestServiceType };
}

export const useCreateReturnRequest = (
   pharmacyId: string,
   handlers?: MutationHandlers<
      MutationVariables,
      AxiosResponse<any> | undefined
   >
): [
   any | undefined,
   (
      locationState?: { serviceType: ReturnRequestServiceType },
      handlers?: Omit<
         MutationHandlers<MutationVariables, AxiosResponse<any> | undefined>,
         'onMutate'
      >
   ) => void,
   Omit<UseMutationResult<any, unknown, MutationVariables>, 'data' | 'mutate'>
] => {
   const { postMethod } = useApiService();

   const { data, mutate, ...state } = useMutation({
      mutationKey: [`POST:/pharmacies/${pharmacyId}/returnrequests`],
      mutationFn: async ({ locationState }: MutationVariables) => {
         return postMethod(
            `/pharmacies/${pharmacyId}/returnrequests`,
            locationState
         );
      },
      onError: handlers?.onError,
      onSuccess: handlers?.onSuccess,
      onSettled: handlers?.onSettled,
      onMutate: handlers?.onMutate,
   });

   return [
      data,
      (
         locationState: { serviceType: ReturnRequestServiceType } = {
            serviceType: ReturnRequestServiceType.ExpressService,
         },
         handlers?: Omit<
            MutationHandlers<MutationVariables, AxiosResponse<any> | undefined>,
            'onMutate'
         >
      ) =>
         mutate(
            { locationState },
            {
               onError: handlers?.onError,
               onSuccess: handlers?.onSuccess,
               onSettled: handlers?.onSettled,
            }
         ),
      state,
   ];
};
